<template>
  <Card class="additional-card" :class="classesCard" background="none">
    <div class="additional-card__header">
      <div class="additional-card__header-left">
        <span>{{ typeTranslate[item.type] }}</span>
        <h3>{{ item.content }}</h3>
      </div>
      <svg-icon :name="`tasks/${item.type}`" />
    </div>
    <div class="additional-card__body">Задание {{ item.number }}</div>
    <div class="additional-card__footer">
      <button>
        <svg-icon name="play" />
        Начать
      </button>
      <span>{{ item.points }} {{ item.points | pluralize('очко', 'очка', 'очков') }}</span>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Common/Card'

export default {
  name: 'AdditionalCard',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    classesCard() {
      return [`additional-card--${this.item.type}`]
    },

    isCompleted() {
      return this.item.status === 2
    },

    isLock() {
      return this.item.status === 0
    },

    typeTranslate() {
      return {
        letters: 'Тренажёр',
        material: 'Образовательный материал',
        content: 'Контент',
        test: 'Тест'
      }
    }
  },

  components: {
    Card
  }
}
</script>

<style scoped lang="scss">
.additional-card {
  box-shadow: none !important;
  background-repeat: no-repeat;
  background-color: $white;
  background-position: right;

  &--letters {
    background-image: url('/img/letters-background.svg?v=3');
  }

  &--content {
    background-image: url('/img/content-background.svg?v=3');
  }

  &--test {
    background-image: url('/img/test-background.svg?v=3');
  }

  &--material {
    background-image: url('/img/material-background.svg?v=12');
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    & > svg {
      width: 56px;
      height: 56px;
    }

    &-left {
      span {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.1px;
        color: $manatee;
      }

      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: $deepdark;
        margin-top: 8px;

        @include md-and-down {
          font-size: 15px;
        }
      }
    }

    & > svg::v-deep {
      border-radius: 16px;

      .background {
        fill: $jaffa;

        &-stroke {
          stroke: $jaffa;
        }
      }

      .content {
        fill: $whisper;

        &-stroke {
          stroke: $whisper;
        }
      }
    }
  }

  &__body {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: $manatee;
    margin: 16px 0 40px;

    @include md-and-down {
      margin: 24px 0 32px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-weight: 500;
      font-size: 24px;
      color: $luchmara;

      @include md-and-down {
        font-size: 20px;
      }
    }

    button {
      background: $whisper;
      width: 110px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      font-weight: 500;
      font-size: 18px;
      letter-spacing: 0.2px;
      color: rgba($deepdark, 0.5);

      svg {
        width: 14px;
        margin-right: 10px;
        fill: $luchmara;
      }
    }
  }
}
</style>
